<lh-navigation-layout-page
    class="portal-wrapper-fw"
    highlightProduct="promo"
    id="mypromotions-page"
    sourceItem="mypromotions"
    [topMenuVisibility]="newAccountMenuService.hideTopMenu('mypromotions')">
    <div class="promotion-container" [class.has-tabs]="initData.viewModel.tabItems.length > 1 && this.showNav">
        <div class="promotion-header">
            <pt-scrolling-navigation [items]="initData.viewModel.tabItems" (onTabSelected)="onTabSelected($event)"> </pt-scrolling-navigation>
        </div>
        @for (tab of initData.viewModel.tabItems | filterActiveTab: selectedProduct; track $index) {
            @if (!isTopPromotion) {
                <div
                    class="cards"
                    [class.width-restricted-medium]="!tab.tabContent.emptyContent"
                    [class.width-restricted-small]="tab.tabContent.emptyContent">
                    @if (tab.tabContent?.promotionItems.length > 0) {
                        @for (item of tab.tabContent.promotionItems; track $index) {
                            <div class="card" [attr.promotion-id]="item.folderId">
                                <div class="promotion vn-profile-img" (click)="promotionClick(item)">
                                    <img class="top-img profile-img-width" [vnProfilesSrc]="item.imageUrl" />
                                    <h2 class="promotion-headline" [innerHtml]="item.title"></h2>
                                    @if (item.shortDescription) {
                                        <div class="promotion-body" [vnDynamicHtml]="item.shortDescription"></div>
                                    }
                                </div>
                                @for (cta of item.ctas; track $index) {
                                    <a class="promotion-link" (click)="ctaClick($event, cta)">
                                        <span class="promotion-span" [innerHtml]="cta.text"></span>
                                        <i class="theme-right"></i>
                                    </a>
                                }
                                @for (cta of item.smartCtas; track $index) {
                                    <div class="pb-1" [vnDynamicHtml]="cta"></div>
                                }
                            </div>
                        }
                    }
                    @if (tab.tabContent.emptyContent) {
                        <div [innerHtml]="tab.tabContent.emptyContent | trustAsHtml"></div>
                    }
                </div>
            }
        }
        @if (hasIframe) {
            <div id="iframe-promotions">
                <iframe id="my-promotions-iframe" [src]="iframeUrl | trustAsResourceUrl"></iframe>
            </div>
        }
        @if (isTopPromotion && !user.isAuthenticated) {
            <div class="login-prompt cards">
                <div class="card">
                    <h2 [innerHtml]="initData.content.loginPrompt.title"></h2>
                    <div [innerHtml]="initData.content.loginPrompt.text | trustAsHtml"></div>
                    <div class="btn login btn-primary" [innerHtml]="initData.content.loginPrompt.messages.buttonLogin" (click)="goToLogin()"></div>
                </div>
            </div>
        }
    </div>
</lh-navigation-layout-page>
